import moment from 'moment';

// 判断如果是moment的话进行额外的format
export const handleMomentData = (data) => {
  if (moment.isMoment(data)) {
    data = data.format('MM/DD/YYYY');
  }
  return data;
};

// 处理可编辑表格数据
export const handleEditTableData = ({ formVal = {}, tableData = [] }) => {
  const newObj = {};
  Object.keys(formVal).forEach((key) => {
    const [dataIndex, id] = key.split('_');
    if (newObj[id]) {
      newObj[id][dataIndex] = handleMomentData(formVal[key]);
    } else {
      newObj[id] = { [dataIndex]: handleMomentData(formVal[key]) };
    }
  });

  const newArr = tableData.map((item) => {
    const newItem = { ...item, ...newObj[item.id], rowIndex: item.id };
    Object.keys(item).forEach((key) => {
      if (
        !newItem[`${key}_${item.id}`] &&
        key !== 'rowIndex' &&
        key !== 'id' &&
        !key.split('_')?.[1]
      ) {
        newItem[`${key}_${item.id}`] = item[key];
      }
    });
    return newItem;
  });
  return newArr;
};

// 返回纯净的数据 - 去除掉 『_id』
export const returnPureData = (data) =>
  data.map((item) => {
    const newItem = {};
    Object.keys(item).forEach((key) => {
      if (!key.split('_')[1]) {
        newItem[key] = item[key];
      }
    });
    return newItem;
  });

export const returnPureDataWithIdValue = (data) =>
  data.map((item) => {
    const newItem = {};
    Object.keys(item).forEach((key) => {
      if (key.split('_')[1]) {
        newItem[key.split('_')[0]] = item[key];
      }
      if (key === 'id') {
        newItem[key] = item[key];
      }
    });
    return newItem;
  });
